import {commonEventEmitter} from "../commonEventEmitter";

const captcha = () => {
  let formType = null;

  window.onloadFunction = () => {
    if (!window.smartCaptcha) {
      return;
    }

    window.smartCaptcha.render("captcha-container", {
      sitekey: "ysc1_bjm6XdbYPIbEL67d6XgijhteUBhP9bEPtdorVjN5b0eef533", // рабочий
      // sitekey: "ysc1_RRUEHj9bY1pO8Ma6fAmDSUu44W0cJB2X2kHic4Ab6a1b0ccc", // тестовый
      invisible: true, // Сделать капчу невидимой
      test: false,
      callback: onCaptchaGet,
      hideShield: false,
    });
  };

  const onCaptchaGet = (token) => {
    commonEventEmitter.emit(`captcha.get`, token, formType);
  };

  commonEventEmitter.on(`captcha.set-type`, (type) => {
    formType = type;
  });

  commonEventEmitter.on(`captcha.remove`, () => {
    if (!window.smartCaptcha) {
      return;
    }

    window.smartCaptcha.reset();
  });
};

export {captcha};
